module.exports = __webpack_public_path__ + "static/img/gzh.d47219d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/gzh.jpg
// module id = ioaN
// module chunks = 5